enum PresentationType {
    Sd = "SD", Hd = "HD", FourK = "4K", Unknown = "Unknown"
}

export default PresentationType;